import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Descendant } from 'slate';
import { appState } from '../../../../AppState';
import { getUser } from '../../../../AuthConfig';

import SlateEditor from '../../Wysiwyg/SlateEditor';

interface ShowEditorProps {
  isEditorVisible: boolean;
  onChange: (interaction: any) => void;
  teamId: number;
  groupId: number;
  commentBody?: Descendant[];
  disabled: boolean;
  onImagePaste?: (data: File) => void;
  isEndUserPage?: boolean;
  minHeight?: number;
  maxHeight?: number;
  toolbarEnd?: React.ReactNode;
}

const ShowEditor: React.FC<ShowEditorProps> = ({ disabled, isEditorVisible, onChange, commentBody, onImagePaste, isEndUserPage, minHeight, maxHeight, toolbarEnd }: ShowEditorProps) => {
  const onChangeEditorComponent = (data: any) => { onChange(data); };
  const onChangeEditorComponentCallback = useCallback((data: any) => { onChangeEditorComponent(data); }, [onChangeEditorComponent]);

  const commentMemo = useMemo(() => {
    return commentBody ?? [{ children: [{ text: '' }] }];
  }, [commentBody]);

  const [assignees, setAssignees] = useState<PlatformUser[]>([]);
  const currentState = appState();
  const currentUser = getUser();

  useEffect(() => setAssignees(currentState.usersInRole), [currentState.usersInRole]);

  return isEditorVisible ?
    <div>
      <SlateEditor
        onChange={onChangeEditorComponentCallback}
        slateValue={commentMemo}
        readOnly={disabled}
        usersInMention={isEndUserPage ? [] : assignees.filter(a => a.UserName !== currentUser && a.Id !== -1)}
        isFocus={true}
        noImage={true}
        onImagePaste={onImagePaste}
        minHeight={minHeight ? `${minHeight}px` : '4rem'}
        maxHeight={maxHeight ? `${maxHeight}px` : undefined}
        toolbarEnd={toolbarEnd}
      />
    </div> : <></>
}

export default ShowEditor